export default "__VITE_ASSET__CBBt9r4u__"